// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__l89D1"};